import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/css/gallery_style.css";
import "../assets/css/Responsive/gallery_responsive.css";

// Images should be imported or dynamically passed via props
import brass1 from "../assets/images/gallery/brass1.webp";
import brass2 from "../assets/images/gallery/brass2.webp";
import brass3 from "../assets/images/gallery/brass3.webp";
import brass4 from "../assets/images/gallery/brass4.webp";
import brass5 from "../assets/images/gallery/brass5.webp";
import brass6 from "../assets/images/gallery/brass6.webp";
import brass7 from "../assets/images/gallery/brass7.webp";
import brass8 from "../assets/images/gallery/brass8.webp";
// import brass9 from "../assets/images/gallery/brass9.webp";
import cnc1 from "../assets/images/gallery/cnc1.webp";
import cnc2 from "../assets/images/gallery/cnc2.webp";
import cnc3 from "../assets/images/gallery/cnc3.webp";
import cnc4 from "../assets/images/gallery/cnc4.webp";
import galleryIcon from "../assets/images/gallery/gallery-icon.webp";
import mbLogo from "../assets/images/gallery/mb-logo-vector.webp";

export default function Gallery() {
  document.title = "Milan Brass – Gallery";
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false, // allow animations to trigger on both scroll down and up
    });
    AOS.refresh();
  }, []);

  return (
    <section className="gallery-section">
      <div className="container">
        {/* <h2 className="gallery-title">Gallery</h2>
        <p className="gallery-subtitle">
          Quality products, exceptional results.
        </p>  */}
        <section className="gallery-header-section">
          <div className="gallery-header-overlay">
            <div
              className="gallery-text"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <h2>Gallery</h2>
              <hr />
              <p>Quality products, exceptional results.</p>
            </div>
            <div
              className="gallery-icon"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <img src={galleryIcon} alt="Gallery Icon" />
            </div>
          </div>
        </section>

        <div className="brass-section" data-aos="fade-up" data-aos-delay="200">
          <h3 className="brass-title">Brass CPVC/PPR Inserts</h3>
          <p className="brass-description">
            Owing to our expertise in this domain, we are engaged in offering
            supreme quality CPVC/PPR Brass Inserts to our valued customers.
            These are manufactured using advanced technology following
            international standards. The brass cpvc inserts, brass ppr inserts
            offered by us can be availed as per various requirements of our
            clients and can be utilized in various industrial applications. Our
            proposed fittings have gained huge adulation for their reliability,
            consistent finish and sturdy designs. These are even tested by our
            experienced professionals against various set parameters and
            standards of quality to ensure their flawlessness. CPVC/PPR Pipe
            inserts are mostly applicable in the plumbing sector where pipe
            fittings are to be done.
          </p>

          <table
            className="brass-specs"
            data-aos="fade-right"
            data-aos-delay="300"
          >
            <thead>
              <tr>
                <th>Thread</th>
                <td>Metric, BSP, BSPT, NPT, NPTF, ISO, etc.</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Material</th>
                <td>
                  All inserts are available in special grades as per customer
                  requirement
                </td>
              </tr>
              <tr>
                <th>Finish</th>
                <td>
                  Natural, chrome or any finishing as per customer requirement
                </td>
              </tr>
            </tbody>
          </table>

          {/* <div className="brass-images-grid">
            {[
              brass1,
              brass2,
              brass3,
              brass4,
              brass5,
              brass6,
              brass7,
              brass8,
              //   brass9,
            ].map((img, index) => (
              <img
                src={img}
                alt={`Brass Insert ${index + 1}`}
                key={index}
                className="brass-image"
              />
            ))}
          </div> */}
          {/* <div className="brass-images-grid" data-aos="zoom-in-up" data-aos-delay="400">
            {[
              brass1,
              brass2,
              brass3,
              brass4,
              brass5,
              brass6,
              brass7,
              brass8,
            ].map((img, index) => (
              <div className="brass-image-wrapper" key={index}>
                <img
                  src={img}
                  alt={`Brass Insert ${index + 1}`}
                  className="brass-image"
                />
                <img src={mbLogo} className="logogallery tl" alt="logo" />
                <img src={mbLogo} className="logogallery tr" alt="logo" />
                <img src={mbLogo} className="logogallery center" alt="logo" />
                <img src={mbLogo} className="logogallery bl" alt="logo" />
                <img src={mbLogo} className="logogallery br" alt="logo" />
              </div>
            ))}
          </div> */}
          <div
            className="brass-images-grid"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            {[
              brass1,
              brass2,
              brass3,
              brass4,
              brass5,
              brass6,
              brass7,
              brass8,
            ].map((img, index) => (
              <div
                className="brass-image-wrapper"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={200 + index * 150}
              >
                <img
                  src={img}
                  alt={`Brass Insert ${index + 1}`}
                  className="brass-image"
                />
                <img src={mbLogo} className="logogallery tl" alt="logo" />
                <img src={mbLogo} className="logogallery tr" alt="logo" />
                <img src={mbLogo} className="logogallery center" alt="logo" />
                <img src={mbLogo} className="logogallery bl" alt="logo" />
                <img src={mbLogo} className="logogallery br" alt="logo" />
              </div>
            ))}
          </div>
        </div>

        {/* <div
          className="machinery-section"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <h3 className="machinery-title">Machinery</h3>
          <hr />
          <div className="machinery-images">
            {[cnc1, cnc2, cnc3, cnc4].map((img, index) => (
              <img
                src={img}
                alt={`Machinery ${index + 1}`}
                key={index}
                className="machinery-image"
              />
            ))}
          </div>
        </div> */}

        <div
          className="machinery-section"
          data-aos="zoom-in-up"
          data-aos-delay="100"
        >
          <h3 className="machinery-title">Machinery</h3>
          <hr />
          <div className="machinery-images">
            {[cnc1, cnc2, cnc3, cnc4].map((img, index) => (
              <img
                src={img}
                alt={`Machinery ${index + 1}`}
                key={index}
                className="machinery-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"} // alternating effect
                data-aos-delay={200 + index * 150} // staggered animation delay
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
